import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row g-4" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "card mb-0 border-0 rounded-2 bg-white letter-spacing shadow-sm h-100" }
const _hoisted_4 = { class: "card-body p-20 p-md-25 p-lg-30" }
const _hoisted_5 = { class: "mb-15 mb-lg-20" }
const _hoisted_6 = { class: "card-title fw-bold mb-2" }
const _hoisted_7 = { class: "text-muted mb-0 fs-13" }
const _hoisted_8 = { class: "config-section-box p-15 p-lg-20" }
const _hoisted_9 = {
  key: 0,
  class: "col-12"
}
const _hoisted_10 = { class: "alert alert-danger py-10 px-15 mb-0 fs-14" }
const _hoisted_11 = {
  key: 0,
  class: "fw-semibold"
}
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = {
  for: "validationCustom01",
  class: "form-label fw-medium"
}
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "col-12 d-flex justify-content-end flex-wrap gap-10 mt-10" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_21 = { class: "col-lg-6" }
const _hoisted_22 = { class: "card mb-0 border-0 rounded-2 bg-white letter-spacing shadow-sm h-100" }
const _hoisted_23 = { class: "card-body p-20 p-md-25 p-lg-30" }
const _hoisted_24 = { class: "mb-15 mb-lg-20" }
const _hoisted_25 = { class: "card-title fw-bold mb-2" }
const _hoisted_26 = { class: "text-muted mb-0 fs-13" }
const _hoisted_27 = { class: "config-section-box p-15 p-lg-20" }
const _hoisted_28 = {
  key: 0,
  class: "col-12"
}
const _hoisted_29 = { class: "alert alert-danger py-10 px-15 mb-0 fs-14" }
const _hoisted_30 = {
  key: 0,
  class: "fw-semibold"
}
const _hoisted_31 = { class: "col-auto" }
const _hoisted_32 = { class: "logo-preview-wrapper" }
const _hoisted_33 = ["src"]
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 2,
  class: "logo-preview-placeholder"
}
const _hoisted_36 = { class: "col" }
const _hoisted_37 = {
  for: "logo",
  class: "form-label fw-medium"
}
const _hoisted_38 = { class: "fs-12 text-muted d-block mt-6" }
const _hoisted_39 = { class: "col-12 d-flex justify-content-end mt-10" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_42 = { class: "col-lg-6" }
const _hoisted_43 = { class: "card mb-0 border-0 rounded-2 bg-white letter-spacing shadow-sm h-100" }
const _hoisted_44 = { class: "card-body p-20 p-md-25 p-lg-30" }
const _hoisted_45 = { class: "mb-15 mb-lg-20" }
const _hoisted_46 = { class: "card-title fw-bold mb-2" }
const _hoisted_47 = { class: "text-muted mb-0 fs-13" }
const _hoisted_48 = { class: "config-section-box p-15 p-lg-20" }
const _hoisted_49 = {
  key: 0,
  class: "col-12"
}
const _hoisted_50 = { class: "alert alert-danger py-10 px-15 mb-0 fs-14" }
const _hoisted_51 = {
  key: 0,
  class: "fw-semibold"
}
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = {
  for: "status",
  class: "form-label fw-medium"
}
const _hoisted_54 = ["selected"]
const _hoisted_55 = ["selected"]
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = {
  class: "d-block text-black fw-medium mb-10",
  for: "duration"
}
const _hoisted_58 = ["placeholder"]
const _hoisted_59 = { class: "col-12 d-flex justify-content-end mt-10" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_62 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_63 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_64 = { class: "modal-content" }
const _hoisted_65 = { class: "modal-header" }
const _hoisted_66 = { class: "modal-title fs-5" }
const _hoisted_67 = { class: "modal-body" }
const _hoisted_68 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_69 = { class: "row form-control shadow-none d-flex flex-row align-items-center mx-0" }
const _hoisted_70 = { class: "col-auto ps-0" }
const _hoisted_71 = {
  class: "alert mt-15 mb-0 py-10 px-15 fs-14",
  style: {"background-color":"#FFF6E9","border":"1px solid #F3D9AE","color":"#7A5211"}
}
const _hoisted_72 = { class: "modal-footer" }

import { ref, onMounted, onBeforeMount, reactive, inject, computed } from "vue";
import * as yup from 'yup';
import axios from 'axios';
import { Modal } from "bootstrap";
import { useI18n } from "vue-i18n";
import { current_permissions } from '../../utils/permission';
import { redirect } from '../../utils/services';
import router from '../../router/index'
import { showToast, checkSessionValidate, img_src, validate_phone_number } from "@/utils/function";
import { Business, Logo, Organization } from "@/utils/Model";


export default /*@__PURE__*/_defineComponent({
  __name: 'GeneralSetting',
  setup(__props) {


const filename = ref('');
const image = ref('');
const selectedValidation = ref(false);
const organization = ref({} as Organization);
const logo = ref(new Array<Logo>());
const secretKey = ref('');
const duration = ref(0);
const backApi = inject('back');
const btnLoad = ref(true);
const { t } = useI18n();
const btnLoad1 = ref(true);
const btnLoadLogo = ref(true);
const errorsLogo = ref('');
const errorIdLogo = ref('');
const errors = ref('');
const errorId = ref('');
const success = ref('');
const btnLoadValidation = ref(true);
const errorsValidation = ref('');
const errorIdValidation = ref('');
const errorsBis = { 'url': '' };
const formValues = reactive({
  url: ""
});

// AJOUTÉ: taille max affichée dans le hint sous le champ logo, dérivée de la même
// variable d'environnement utilisée pour la validation (au lieu de la répéter à la main)
const maxImgSizeKb = process.env.VUE_APP_IMG_SIZE;

const schema = yup.object({
  url: yup.string().required('L\'url de notification est requise'),
});
const token = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');

function handleValidationChange(event) {
  selectedValidation.value = false;
  if (event.target.value == 'ACTIVE') {
    selectedValidation.value = true;
  }
}

onMounted(() => {
  checkSessionValidate(1);
  getCallBackUrl();
  getLogo();
  showOrganizationInfo();
});

const storeUrl = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/webhooks/url`, {
      url: formValues.url,
      organization: codeOrganization,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Enregistrement effectué avec succès", "green");
      }
    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    btnLoad.value = true;
    errors.value = "une erreur inattendue est apparue"
  }
}

// MODIFIÉ: ouverture du modal via l'API Bootstrap (Modal.getOrCreateInstance) au lieu
// du bouton caché déclenché par un faux clic — plus robuste et plus lisible.
const generateSecretKey = () => {
  btnLoad1.value = false;
  try {
    axios.post(`${backApi}/secure/webhooks/token`, {
      url: formValues.url,
      organization: codeOrganization,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad1.value = true;
      if (response.status === 200) {
        secretKey.value = response.data.webhookToken;
        const modalEl = document.getElementById('filterLeadModal');
        const modalInstance = Modal.getOrCreateInstance(modalEl);
        modalInstance.show();
      }
    }).catch((error) => {
      btnLoad1.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    btnLoad1.value = true;
    errors.value = "une erreur inattendue est apparue"
  }
}

const getCallBackUrl = () => {
  axios.get(backApi + '/secure/webhooks/show-webhook', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.url = response.data
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = '';
  success.value = '';
}

function copyToCliboard() {
  navigator.clipboard.writeText(secretKey.value);
  showToast("Copié", "green");
}

const handleImageUpload = (event) => {
  const file = event.target.files[0]
  const fileSize = file.size / 1024;
  if (fileSize <= parseInt(process.env.VUE_APP_IMG_SIZE)) {
    filename.value = file;
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      image.value = reader.result
    }
  } else {
    showToast("la taille maximum autorisée est " + process.env.VUE_APP_IMG_SIZE + " kb!", "red");
    (document.getElementById("logo") as HTMLInputElement).value = '';
  }
}

const updateImage = () => {
  btnLoadLogo.value = false;
  const formdata = new FormData();
  formdata.append('file', filename.value);
  formdata.append('organization', codeOrganization);
  axios.post(backApi + '/secure/organizations/logo', formdata, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      btnLoadLogo.value = true;
      if (response.status === 200) {
        logo.value = response.data;
        showToast("Enregistrement effectué avec succès", "green");
      }
    })
    .catch((error) => {
      btnLoadLogo.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorIdLogo.value = error.response.data.errorId;
          errorsLogo.value = error.response.data.message;
        }
      }
    })
};

const getLogo = () => {
  axios.get(backApi + `/secure/organizations/${codeOrganization}/logo`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      logo.value = response.data;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const imgSrc = computed(() => {
  const temp = logo.value;
  return img_src(temp[0]?.storageUrl)
})

const showOrganizationInfo = () => {
  axios.get(backApi + '/secure/organizations/' + codeOrganization + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      organization.value = response.data;
      selectedValidation.value = response.data.validatePayoutBeforProcess;
      duration.value = response.data.payoutValidationDelay;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const updateTransactionValidationConfig = () => {
  btnLoadValidation.value = false;

  axios.put(backApi + '/secure/organizations/' + codeOrganization + '/edit',
    {
      validatePayoutBeforProcess: selectedValidation.value,
      payoutValidationDelay: duration.value,
    }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      btnLoadValidation.value = true;
      if (response.status === 200) {
        showToast("Enregistrement effectué avec succès", "green");
      }
    })
    .catch((error) => {
      btnLoadValidation.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorIdValidation.value = error.response.data.errorId;
          errorsValidation.value = error.response.data.message;
        }
      }
    })
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t('generalConfig.notificationUrlConfig')), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('generalConfig.notificationUrlConfigHint') || 'Recevez vos notifications de transactions sur cette URL.'), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("form", {
                id: "callback",
                onSubmit: _withModifiers(storeUrl, ["prevent"]),
                class: "row g-3 needs-validation",
                novalidate: ""
              }, [
                (errors.value!=='')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (errorId.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(errorId.value), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, _toDisplayString(errors.value), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('generalConfig.url')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["form-control shadow-none fs-md-15 text-black", { 'is-invalid': errorsBis['url'] }]),
                    id: "validationCustom01",
                    placeholder: _ctx.$t('generalConfig.urlPlaceholder'),
                    required: "",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formValues.url) = $event)),
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (validate('url')))
                  }, null, 42, _hoisted_14), [
                    [_vModelText, formValues.url]
                  ]),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(errorsBis['url']), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (_unref(current_permissions)('config_webhook_token'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: !btnLoad1.value,
                        class: "btn btn-outline-secondary d-inline-flex align-items-center gap-8",
                        type: "button",
                        onClick: generateSecretKey
                      }, [
                        (!btnLoad1.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('generalConfig.generateSecretKey')), 1)
                      ], 8, _hoisted_17))
                    : _createCommentVNode("", true),
                  (_unref(current_permissions)('config_webhook_url'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        disabled: !btnLoad.value,
                        class: "btn text-white d-inline-flex align-items-center gap-8",
                        type: "submit",
                        style: {"background-color":"#EB9355"}
                      }, [
                        (!btnLoad.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('generalConfig.saveUrl')), 1)
                      ], 8, _hoisted_19))
                    : _createCommentVNode("", true)
                ])
              ], 32)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("h5", _hoisted_25, _toDisplayString(_ctx.$t('generalConfig.logoConfig')), 1),
              _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('generalConfig.logoConfigHint') || 'Ce logo est utilisé sur vos documents et votre espace.'), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("form", {
                id: "callback1",
                onSubmit: _withModifiers(updateImage, ["prevent"]),
                class: "row g-3 align-items-center"
              }, [
                (errorsLogo.value!=='')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        (errorIdLogo.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(errorIdLogo.value), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, _toDisplayString(errorsLogo.value), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    (image.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: image.value,
                          class: "logo-preview-img"
                        }, null, 8, _hoisted_33))
                      : (imgSrc.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: imgSrc.value,
                            class: "logo-preview-img"
                          }, null, 8, _hoisted_34))
                        : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString((organization.value?.name || '?').charAt(0).toUpperCase()), 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('generalConfig.logo')), 1),
                  _createElementVNode("input", {
                    type: "file",
                    class: "form-control shadow-none fs-md-15 text-black",
                    id: "logo",
                    accept: "image/*",
                    onChange: handleImageUpload,
                    required: ""
                  }, null, 32),
                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('generalConfig.logoSizeHint', { size: _unref(maxImgSizeKb) }) || `Taille maximum : ${_unref(maxImgSizeKb)} ko`), 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  (_unref(current_permissions)('org_logo'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: !btnLoadLogo.value,
                        class: "btn text-white d-inline-flex align-items-center gap-8",
                        type: "submit",
                        style: {"background-color":"#EB9355"}
                      }, [
                        (!btnLoadLogo.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('generalConfig.saveLogo')), 1)
                      ], 8, _hoisted_40))
                    : _createCommentVNode("", true)
                ])
              ], 32)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("h5", _hoisted_46, _toDisplayString(_ctx.$t('generalConfig.transactionValidation')), 1),
              _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t('generalConfig.transactionValidationHint') || 'Exigez une validation manuelle avant traitement des paiements sortants.'), 1)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("form", {
                id: "callback2",
                onSubmit: _withModifiers(updateTransactionValidationConfig, ["prevent"]),
                class: "row g-3"
              }, [
                (errorsValidation.value!=='')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        (errorIdValidation.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(errorIdValidation.value), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, _toDisplayString(errorsValidation.value), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('generalConfig.validateTransactions')), 1),
                  _createElementVNode("select", {
                    name: "status",
                    id: "status",
                    class: "form-select fs-md-15 text-black shadow-none",
                    onChange: handleValidationChange,
                    required: ""
                  }, [
                    _createElementVNode("option", {
                      value: "INACTIVE",
                      selected: selectedValidation.value==false
                    }, _toDisplayString(_ctx.$t('generalConfig.inactive')), 9, _hoisted_54),
                    _createElementVNode("option", {
                      value: "ACTIVE",
                      selected: selectedValidation.value==true
                    }, _toDisplayString(_ctx.$t('generalConfig.active')), 9, _hoisted_55)
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('generalConfig.linkValidityDuration')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    min: "0",
                    class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                    placeholder: _ctx.$t('generalConfig.durationPlaceholder'),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((duration).value = $event)),
                    id: "duration",
                    onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_unref(validate_phone_number)($event.target.value,$event.target,3)))
                  }, null, 40, _hoisted_58), [
                    [_vModelText, duration.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  (_unref(current_permissions)('edit_organization'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: !btnLoadValidation.value,
                        class: "btn text-white d-inline-flex align-items-center gap-8",
                        type: "submit",
                        style: {"background-color":"#EB9355"}
                      }, [
                        (!btnLoadValidation.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_61))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('generalConfig.save')), 1)
                      ], 8, _hoisted_60))
                    : _createCommentVNode("", true)
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("h1", _hoisted_66, _toDisplayString(_ctx.$t('generalConfig.secretKey')), 1),
            _cache[5] || (_cache[5] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t('generalConfig.yourSecretKey')), 1),
            _createElementVNode("div", _hoisted_69, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                readonly: "",
                class: "col fw-medium text-black fs-md-15 fs-lg-16 border-0",
                id: "secretKeyInput",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((secretKey).value = $event)),
                style: {"background":"transparent","font-family":"'Courier New', monospace"}
              }, null, 512), [
                [_vModelText, secretKey.value]
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("a", {
                  href: "#",
                  class: "text-decoration-none d-block text-center fw-semibold",
                  style: {"color":"#EB9355"},
                  onClick: _withModifiers(copyToCliboard, ["prevent"])
                }, _toDisplayString(_ctx.$t('generalConfig.copy') || 'Copier'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.$t('generalConfig.secretKeyNote')), 1)
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("button", {
              type: "button",
              class: "btn text-white",
              style: {"background-color":"#EB9355"},
              onClick: _withModifiers(copyToCliboard, ["prevent"])
            }, _toDisplayString(_ctx.$t('generalConfig.copy') || 'Copier'), 1)
          ])
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})